import React from "react";
import PropTypes from "prop-types";
import { Button } from "semantic-ui-react";

const ActionButtons = ({
  patron,
  onPayFine,
  onOverdueSlip,
  onViewPaymentHistory,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem",
        minWidth: "150px",
      }}
    >
      <Button
        compact
        icon="print"
        onClick={() => onOverdueSlip(patron)}
        data-test={`slip-${patron.pid}`}
        fluid
        content="Overdue Slip"
        style={{
          border: "2px solid red",
          borderRadius: "4px",
          background: "transparent",
          color: "red",
        }}
      />
      <Button
        compact
        onClick={() => onPayFine(patron)}
        data-test={`pay-${patron.pid}`}
        fluid
        content={`Pay ₱${patron.totalFine.toFixed(2)}`}
        style={{
          border: "2px solid darkgreen",
          borderRadius: "4px",
          background: "transparent",
          color: "darkgreen",
        }}
      />
      <Button
        compact
        icon="history"
        onClick={() => onViewPaymentHistory(patron)}
        data-test={`history-${patron.pid}`}
        fluid
        content="Payment History"
        style={{
          border: "2px solid gray",
          borderRadius: "4px",
          background: "transparent",
          color: "gray",
        }}
      />
    </div>
  );
};

ActionButtons.propTypes = {
  patron: PropTypes.shape({
    pid: PropTypes.string.isRequired,
    totalFine: PropTypes.number.isRequired,
  }).isRequired,
  onPayFine: PropTypes.func.isRequired,
  onOverdueSlip: PropTypes.func.isRequired,
  onViewPaymentHistory: PropTypes.func.isRequired,
};

export default ActionButtons;
